import { Button, ScrollArea } from '@consigli/shadcn';
import { useState } from 'react';
import { MdContentCopy, MdCheck } from 'react-icons/md';
import SyntaxHighlighter from 'react-syntax-highlighter';
import { tomorrow } from 'react-syntax-highlighter/dist/esm/styles/hljs';

import { Modal } from './modal/modal';

interface ObjectDetailViewProps {
  object: object;
  objectType: string;
  summary: string;
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
}

export const ObjectDetailView = ({
  object,
  objectType,
  summary,
  isOpen,
  onOpenChange,
}: ObjectDetailViewProps) => {
  const [copied, setCopied] = useState(false);
  const jsonString = JSON.stringify(object, null, 2);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(jsonString);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy text: ', err);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      title={`${objectType} Details`}
      description={summary}
      className="max-w-4xl w-full"
      showCloseButton={true}
    >
      <div className="relative">
        <Button
          variant="ghost"
          size="sm"
          onClick={handleCopy}
          className="absolute top-2 right-2 z-10 h-8 w-8 p-0 hover:bg-gray-100 dark:hover:bg-gray-800"
          title={copied ? 'Copied!' : 'Copy JSON'}
        >
          {copied ? (
            <MdCheck className="h-4 w-4 text-green-600" />
          ) : (
            <MdContentCopy className="h-4 w-4 text-gray-600" />
          )}
        </Button>
        <ScrollArea className="max-h-120 w-full">
          <div className="w-full overflow-hidden">
            <SyntaxHighlighter
              className="text-sm !m-0 !p-4 max-h-120"
              language="json"
              style={tomorrow}
              customStyle={{
                margin: 0,
                padding: '1rem',
                backgroundColor: '#f8f9fa',
                borderRadius: '0.375rem',
                fontSize: '0.875rem',
                lineHeight: '1.5',
                wordBreak: 'break-word',
                overflowWrap: 'break-word',
                whiteSpace: 'pre-wrap',
                maxHeight: '30rem',
                overflow: 'auto',
              }}
              wrapLines={true}
              wrapLongLines={true}
            >
              {jsonString}
            </SyntaxHighlighter>
          </div>
        </ScrollArea>
      </div>
    </Modal>
  );
};
